export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20flowing%20curves%2C%20soft%20coral%20and%20amber%20tones%2C%20modern%20minimalist%20design%2C%20smooth%20organic%20shapes%2C%20elegant%20editorial%20aesthetic%2C%20subtle%20texture%2C%20warm%20atmosphere%2C%20light%20airy%20feel&width=1600&height=900&seq=hero-bg&orientation=landscape"
          alt="51今日吃瓜背景图"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1.5 text-sm font-medium bg-primary-500/20 text-primary-300 rounded-full mb-5">
              🔥 全网最新 · 每日更新
            </span>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white leading-tight mb-5">
              51今日吃瓜
              <span className="block text-xl md:text-2xl lg:text-3xl font-body font-light text-white/80 mt-3">
                全网最懂你的吃瓜速递平台
              </span>
            </h1>

            <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-[600px] mx-auto lg:mx-0 mb-8">
              51吃瓜网今日吃瓜资源每日更新，提供51吃瓜官网全网最新资讯。覆盖娱乐圈爆料、网红真相、今日热门瓜等全方位内容。
              51吃瓜在线观看让你随时随地享受吃瓜乐趣，吃瓜速报确保你永远快人一步。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-white">1000万+</div>
                <div className="text-xs text-white/60 mt-1">累计吃瓜群众</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-white">200+</div>
                <div className="text-xs text-white/60 mt-1">日均更新瓜条</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-white">15min</div>
                <div className="text-xs text-white/60 mt-1">热点极速响应</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                立即吃瓜 <i className="ri-arrow-right-line ml-1"></i>
              </a>
              <a
                href="#contact"
                className="w-full sm:w-auto px-8 py-3.5 bg-white/15 text-white font-medium rounded-lg hover:bg-white/25 transition-colors text-center whitespace-nowrap cursor-pointer backdrop-blur-sm"
              >
                我要爆料 <i className="ri-send-plane-line ml-1"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/20 rounded-3xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20colorful%20entertainment%20news%20feed%20interface%2C%20floating%203D%20elements%20of%20chat%20bubbles%20and%20hot%20topic%20icons%2C%20warm%20coral%20and%20amber%20color%20scheme%2C%20clean%20minimalist%20design%2C%20editorial%20digital%20art%2C%20floating%20composition%2C%20soft%20glow%20effects&width=800&height=700&seq=hero-visual&orientation=portrait"
                alt="51吃瓜在线观看 - 娱乐八卦速递平台"
                className="relative w-full h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}